import React, { useEffect } from "react";
import { compose, withState, lifecycle } from "recompose";
import EnhanceProduct from "./EnhanceProduct";
import PartialProductQuery from "./PartialProductQuery.gql";
import ProductQuery from "./ProductQuery.gql";
import withTrackPage from "theme/modules/Analytics/withTrackPage";
import Loadable from "theme/components/helpers/Loadable";
import ProductBreadcrumb from "theme/modules/ProductView/ProductBreadcrumb";
import ProductView from "theme/modules/ProductView";
import ProductAddedPopIn from "theme/modules/ProductAddedPopIn";
import ProductSeo from "theme/modules/ProductView/ProductSeo";
import withProductTracking from "theme/modules/ProductView/withProductTracking";
import {
  trackGlobalPage,
  trackProductPage,
} from "../../components/helpers/AnalyticsV4/TrackAnlyticsV4";

const Product = (props) => {
  useEffect(() => {
    // force close product add popup when the product changes
    document.querySelector(".product-added button[title=close]")?.click();
    document.querySelector("body")?.classList.remove("ReactModal__Body--open");
  }, [props.product.sku]);
  return (
    <div itemScope itemType="http://schema.org/Product">
      <ProductBreadcrumb product={props.product} />

      <ProductSeo product={props.product} />
      <ProductAddedPopIn
        product={props.productAdded}
        hidePopin={props.hidePopin}
      />
      <ProductView
        product={props.product}
        previewContent={props.previewContent}
        setPreviewContent={props.setPreviewContent}
        onProductAdded={(product) => props.showPopin(product)}
      />
    </div>
  );
};

export default compose(
  EnhanceProduct({
    PartialProductQuery,
    ProductQuery,
  }),
  withTrackPage("Product"),
  trackGlobalPage("product"),
  Loadable((props) => !props.loading, true),
  trackProductPage(),
  withState("previewContent", "setPreviewContent", {
    image: false,
    name: false,
    sku: false,
  }),
  lifecycle({
    componentDidMount() {
      this.props.setPreviewContent({
        image: false,
        name: false,
        sku: false,
      });
    },
  }),
  withProductTracking()
)(Product);
